var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "fora-do-ar" }, [
    _c("div", { staticClass: "forma-azul" }, [
      _vm._m(0),
      _vm._m(1),
      _c("div", { staticClass: "cards" }, [
        _c("div", { staticClass: "card" }, [
          _vm._m(2),
          _vm._m(3),
          _vm._m(4),
          _c("div", { staticClass: "vantagens-plano" }, [
            _c("ul", [
              _c("li", { staticClass: "vantagem-item" }, [
                _c(
                  "div",
                  { staticClass: "img-check" },
                  [
                    _c("v-img", {
                      staticClass: "check",
                      attrs: { src: require("@/assets/icons/check_icon.svg") }
                    })
                  ],
                  1
                ),
                _c("span", [
                  _vm._v(
                    "Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet."
                  )
                ])
              ]),
              _c("li", { staticClass: "vantagem-item" }, [
                _c(
                  "div",
                  { staticClass: "img-check" },
                  [
                    _c("v-img", {
                      staticClass: "check",
                      attrs: { src: require("@/assets/icons/check_icon.svg") }
                    })
                  ],
                  1
                ),
                _c("span", [_vm._v("Amet minim mollit non deserunt")])
              ]),
              _c("li", { staticClass: "vantagem-item" }, [
                _c(
                  "div",
                  { staticClass: "img-check" },
                  [
                    _c("v-img", {
                      staticClass: "check",
                      attrs: { src: require("@/assets/icons/check_icon.svg") }
                    })
                  ],
                  1
                ),
                _c("span", [_vm._v("Amet minim mollit non deserunt")])
              ]),
              _c("li", { staticClass: "vantagem-item" }, [
                _c(
                  "div",
                  { staticClass: "img-check" },
                  [
                    _c("v-img", {
                      staticClass: "check",
                      attrs: { src: require("@/assets/icons/check_icon.svg") }
                    })
                  ],
                  1
                ),
                _c("span", [_vm._v("Amet minim mollit non deserunt")])
              ]),
              _c("li", { staticClass: "vantagem-item" }, [
                _c(
                  "div",
                  { staticClass: "img-check" },
                  [
                    _c("v-img", {
                      staticClass: "check",
                      attrs: { src: require("@/assets/icons/check_icon.svg") }
                    })
                  ],
                  1
                ),
                _c("span", [_vm._v("Amet minim mollit non deserunt")])
              ])
            ])
          ]),
          _vm._m(5)
        ]),
        _c("div", { staticClass: "card" }, [
          _vm._m(6),
          _vm._m(7),
          _vm._m(8),
          _c("div", { staticClass: "vantagens-plano" }, [
            _c("ul", [
              _c("li", { staticClass: "vantagem-item" }, [
                _c(
                  "div",
                  { staticClass: "img-check" },
                  [
                    _c("v-img", {
                      staticClass: "check",
                      attrs: { src: require("@/assets/icons/check_icon.svg") }
                    })
                  ],
                  1
                ),
                _c("span", [
                  _vm._v(
                    "Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet."
                  )
                ])
              ]),
              _c("li", { staticClass: "vantagem-item" }, [
                _c(
                  "div",
                  { staticClass: "img-check" },
                  [
                    _c("v-img", {
                      staticClass: "check",
                      attrs: { src: require("@/assets/icons/check_icon.svg") }
                    })
                  ],
                  1
                ),
                _c("span", [_vm._v("Amet minim mollit non deserunt")])
              ]),
              _c("li", { staticClass: "vantagem-item" }, [
                _c(
                  "div",
                  { staticClass: "img-check" },
                  [
                    _c("v-img", {
                      staticClass: "check",
                      attrs: { src: require("@/assets/icons/check_icon.svg") }
                    })
                  ],
                  1
                ),
                _c("span", [_vm._v("Amet minim mollit non deserunt")])
              ]),
              _c("li", { staticClass: "vantagem-item" }, [
                _c(
                  "div",
                  { staticClass: "img-check" },
                  [
                    _c("v-img", {
                      staticClass: "check",
                      attrs: { src: require("@/assets/icons/check_icon.svg") }
                    })
                  ],
                  1
                ),
                _c("span", [_vm._v("Amet minim mollit non deserunt")])
              ]),
              _c("li", { staticClass: "vantagem-item" }, [
                _c(
                  "div",
                  { staticClass: "img-check" },
                  [
                    _c("v-img", {
                      staticClass: "check",
                      attrs: { src: require("@/assets/icons/check_icon.svg") }
                    })
                  ],
                  1
                ),
                _c("span", [_vm._v("Amet minim mollit non deserunt")])
              ])
            ])
          ]),
          _vm._m(9)
        ]),
        _c("div", { staticClass: "card" }, [
          _vm._m(10),
          _vm._m(11),
          _vm._m(12),
          _c("div", { staticClass: "vantagens-plano" }, [
            _c("ul", [
              _c("li", { staticClass: "vantagem-item" }, [
                _c(
                  "div",
                  { staticClass: "img-check" },
                  [
                    _c("v-img", {
                      staticClass: "check",
                      attrs: { src: require("@/assets/icons/check_icon.svg") }
                    })
                  ],
                  1
                ),
                _c("span", [
                  _vm._v(
                    "Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet."
                  )
                ])
              ]),
              _c("li", { staticClass: "vantagem-item" }, [
                _c(
                  "div",
                  { staticClass: "img-check" },
                  [
                    _c("v-img", {
                      staticClass: "check",
                      attrs: { src: require("@/assets/icons/check_icon.svg") }
                    })
                  ],
                  1
                ),
                _c("span", [_vm._v("Amet minim mollit non deserunt")])
              ]),
              _c("li", { staticClass: "vantagem-item" }, [
                _c(
                  "div",
                  { staticClass: "img-check" },
                  [
                    _c("v-img", {
                      staticClass: "check",
                      attrs: { src: require("@/assets/icons/check_icon.svg") }
                    })
                  ],
                  1
                ),
                _c("span", [_vm._v("Amet minim mollit non deserunt")])
              ]),
              _c("li", { staticClass: "vantagem-item" }, [
                _c(
                  "div",
                  { staticClass: "img-check" },
                  [
                    _c("v-img", {
                      staticClass: "check",
                      attrs: { src: require("@/assets/icons/check_icon.svg") }
                    })
                  ],
                  1
                ),
                _c("span", [_vm._v("Amet minim mollit non deserunt")])
              ]),
              _c("li", { staticClass: "vantagem-item" }, [
                _c(
                  "div",
                  { staticClass: "img-check" },
                  [
                    _c("v-img", {
                      staticClass: "check",
                      attrs: { src: require("@/assets/icons/check_icon.svg") }
                    })
                  ],
                  1
                ),
                _c("span", [_vm._v("Amet minim mollit non deserunt")])
              ])
            ])
          ]),
          _vm._m(13)
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "nav" }, [
      _c("span", [_vm._v("barra navegação")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "textos-capa" }, [
      _c("div", { staticClass: "title" }, [
        _c("span", [
          _vm._v(" Escolha do seu plano "),
          _c("span", { staticClass: "negrito" }, [_vm._v("Kristal Connect")])
        ])
      ]),
      _c("div", { staticClass: "descricao-capa" }, [
        _c("p", [
          _vm._v(
            " Lorem ipsum dolor sit, amet consectetur adipisicing elit. Ipsam nesciunt, deserunt corrupti aut nemo dolore tenetur enim optio sapiente nok, ad non facilis sunt req. "
          )
        ])
      ]),
      _c("div", { staticClass: "btns-capa" }, [
        _c("div", { staticClass: "mensal" }, [_c("span", [_vm._v("Mensal")])]),
        _c("div", { staticClass: "anual" }, [_c("span", [_vm._v("Anual")])])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title-card" }, [
      _c("span", [
        _vm._v("Kristal "),
        _c("span", { staticClass: "tipo-produto" }, [_vm._v("Basic")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "valor" }, [
      _c("span", [_vm._v("R$0,00")]),
      _c("span", { staticClass: "mes" }, [_vm._v("/mês")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "gratuidade" }, [
      _c("span", [_vm._v("Gratuito sempre")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "btn" }, [
      _c("span", [_vm._v("Realizar ação")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title-card" }, [
      _c("span", [
        _vm._v("Kristal "),
        _c("span", { staticClass: "tipo-produto" }, [_vm._v("Basic")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "valor" }, [
      _c("span", [_vm._v("R$0,00")]),
      _c("span", { staticClass: "mes" }, [_vm._v("/mês")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "gratuidade" }, [
      _c("span", [_vm._v("Gratuito sempre")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "btn" }, [
      _c("span", [_vm._v("Realizar ação")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title-card" }, [
      _c("span", [
        _vm._v("Kristal "),
        _c("span", { staticClass: "tipo-produto" }, [_vm._v("Basic")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "valor" }, [
      _c("span", [_vm._v("R$0,00")]),
      _c("span", { staticClass: "mes" }, [_vm._v("/mês")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "gratuidade" }, [
      _c("span", [_vm._v("Gratuito sempre")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "btn" }, [
      _c("span", [_vm._v("Realizar ação")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }